import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyWorkforceAvailabilityStatusIndicatorWithQuery = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-jsm-workforce-indicator" */
			'./WorkforceAvailabilityStatusIndicatorWithQuery.tsx'
		).then((m) => m.WorkforceAvailabilityStatusIndicatorWithQuery),
	{ ssr: false },
);
/**
 * SSR-skipped, after-paint loaded presence indicator for JSM workforce availability.
 */
export const AsyncWorkforceAvailabilityStatusIndicator = (): React.ReactNode => (
	<JSErrorBoundary
		id="async.workforce-availability-indicator"
		packageName="jiraServicedeskWorkforceAvailabilityGlobalMenu"
		teamName="JSD SHIELD"
		fallback={() => null}
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="jsm-workforce-availability-indicator" fallback={null}>
			<LazyWorkforceAvailabilityStatusIndicatorWithQuery />
		</Placeholder>
	</JSErrorBoundary>
);
